import { EXPORT_ENUMS } from '@/constants';

export const exportFormatter = (params: any) => {
  const value = params.value;
  return (
    Object.entries(EXPORT_ENUMS).find(([key, val]) => val === value)?.[0] ?? ''
  );
};
